import {
    _showClearIcon,
    _getInputElStyle,
    _getMaxLengthAttr,
    _getDisabledAttr,
    _getDisabledClass,
} from "./Common_Fun";
import {AssertUtils} from "goingutils";

let HiddenCtl = {
    /**
     * 获取控件的html
     * @param formType 表单类型 分查询表单 和普通表单
     * @param item 选项
     * @param targetObj 可能是GoingForm对象 也可能是QueryForm对象
     */
    getHtml: function (formType, {defVal, id}, targetObj) {
        return ` <input  value="${defVal}" id="${
            targetObj.prefixCls
            }_${id}" class="hiddenEl" type="hidden">`;
    },
    /**
     * 获取但条件查询下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getSingleQueryHtml: function (
        {label, id, required, defVal = ""},
        targetObj
    ) {
        return ` <input  value="${defVal}" id="${
            targetObj.prefixCls
            }_${id}" class="hiddenEl" type="hidden">`;
    },
    //获取显示值
    getShowValue(curVal) {
        return curVal;
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getEditorHtml: function (
        {
            label,
            id,
            required,
            defVal = "",
            maxlength = 0,
            readOnly,
            disabled
        },
        targetObj
    ) {
        return `<span class="row  go-form-row flex-div">
               <input style="${_getInputElStyle(
            targetObj
        )}" :label="label"  ${_getMaxLengthAttr(
            maxlength
        )} value="${defVal}" id="${
            targetObj.prefixCls
            }_${id}" type="text"  ${_getDisabledAttr(
            readOnly,
            disabled
        )} class="go-color-sel form-control padding-l-bs  ${_getDisabledClass(
            readOnly,
            disabled
        )}">
               </span>`;
    },
    clearData(item, formType, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val("");
    },
    /**
     * 初始化提交数据
     * @param item
     * @param targetObj 目标form对象
     * @param backJson 返回的数据
     * @param formType 表单类型
     */
    getSubmitData: function (
        item,
        targetObj,
        backJson,
        formType
    ) {
        if (formType === "query") {
            this.getQuerySubmitData(item, targetObj, backJson);
        } else {
            this.getEditorSubmitData(item, targetObj, backJson);
        }
    },
    getQuerySubmitData: function (item, targetObj, backJson) {
        //如果不为空的情况下才返回查询的值
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        if (AssertUtils.isNotEmpty($("#" + inputElId).val())) {
            backJson[item["id"]] = $("#" + inputElId).val();
        }
    },
    getEditorSubmitData: function (item, targetObj, backJson) {
        //时间
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        backJson[item["id"]] = $("#" + inputElId).val();
    },
    setValue(prop, propValue, item, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val(propValue);
        if (AssertUtils.isNotEmpty(propValue)) {
            _showClearIcon(inputElId);
        }
    },
    getRealValue(value) {
        return value || " ";
    },
    initCtlEvent: function () {
    }
};
export default HiddenCtl;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/go-hidden-input.js